import React from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'
import { Box } from '@rebass/grid/emotion'

import { H4, Paragraph } from '../Typography'
import Image from '../Image'

import { Colors, Gutter } from '../../utils/styles'

const Container = styled(Box)({
  padding: Gutter.HALF,
})

const ContentContainer = styled.div({
  display: 'flex',
  flexDirection: 'column',
})

const Heading = styled(H4)(
  {
    fontSize: 18,
    marginLeft: Gutter.HALF,
    marginBottom: 0,
  },
  props => ({
    color: props.color,
  })
)
const HeadingContainer = styled.div({
  display: 'flex',
  alignItems: 'center',
  marginBottom: Gutter.QUARTER,
})

const QuestionBlock = props => (
  <Container width={[1, 1, 1 / 2]}>
    <ContentContainer>
      <HeadingContainer>
        <Image src={props.icon} width={props.iconSize} height={props.iconSize} />
        <Heading color={props.color}>{props.title}</Heading>
      </HeadingContainer>
      <Paragraph>{props.question}</Paragraph>
    </ContentContainer>
  </Container>
)

export default QuestionBlock

QuestionBlock.propTypes = {
  icon: PropTypes.string,
  iconSize: PropTypes.string,
  title: PropTypes.string,
  question: PropTypes.string,
  color: PropTypes.string,
}

QuestionBlock.defaultProps = {
  icon:
    // eslint-disable-next-line
    'https://res.cloudinary.com/pulsedatatools/image/upload/v1560958986/pulse-analytics-marketing/icons/placeholder-icon.svg',
  iconSize: 48,
  title: 'Quesiton Title',
  question: 'What is the area of a triangle?',
  color: Colors.BLACK,
}
